<div class="modal-header">
  <h1 style="margin: 12px 8px; font-size: 22px; font-weight: 600;">What time do you want your order?</h1>
  <button mat-icon-button (click)="closeModalById('order-wanted-time-modal')">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div class="wanted-time-content">
  <div style="text-align: center; margin: 5px 0 10px;">
    @if (alertMessages?.length > 0) {
      @for (messages of alertMessages; track messages) {
        <span class="alert-message">{{ messages }}</span>
      }
    }

    @if (wantedTimeIssue && (!alertMessages || alertMessages.length === 0)) {
      <span class="alert-message">{{ wantedTimeIssue }}</span>
    }
  </div>

  @if (isLoading) {
    <div style="min-height: 100px;" class="flex-row-centered">
      <div class="lds-dual-ring"></div>
    </div>
  }

  @if (!isLoading && (timeSlots.length > 0 || futureTimeSlots?.length > 0)) {
    <div class="date-selection-container">
      <mat-radio-group [(ngModel)]="dateSelection" (change)="onDateSelectionChange()">
        <div class="radio-option" [class.selected]="dateSelection === 'today'">
          <mat-radio-button
            value="today"
            [disabled]="timeSlots.length === 0"
            class="custom-radio">
            Today
          </mat-radio-button>

        @if (dateSelection === 'today' && timeSlots.length > 0) {
          <div class="time-selection-container">
            <div class="time-dropdown-container">
              <mat-icon class="time-icon">access_time</mat-icon>
              <mat-form-field class="time-dropdown">
                <mat-select
                  placeholder="Find a time for today"
                  [(value)]="initialTime"
                  (selectionChange)="orderTimePicked($event)">
                  @for (slot of timeSlots; track slot) {
                    <mat-option [value]="slot.time" [disabled]="slot.disabled">
                      {{ slot.title }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        }
      </div>

        @if (futureTimeSlots?.length > 0) {
          <div class="radio-option" [class.selected]="dateSelection === 'future'">
            <mat-radio-button
              value="future"
              class="custom-radio">
              Future Date
            </mat-radio-button>

            @if (dateSelection === 'future') {
              <div class="future-date-selection-container">
                <div class="future-dropdown-container">
                  <mat-icon class="date-icon">calendar_month</mat-icon>
                  <mat-form-field class="date-dropdown">
                    <mat-select
                      placeholder="Tomorrow"
                      [(value)]="selectedDate"
                      (selectionChange)="orderDatePicked($event)">
                      <mat-select-trigger>
                        {{ getSelectedDateDisplay() }}
                      </mat-select-trigger>
                      @for (slot of calendarDateGroup; track slot) {
                        <mat-option [value]="slot.calendarDate">
                          <div class="date-option">
                            <div class="day-name">{{ slot.formattedDate.split('|')[0] }}</div>
                            <div class="date-detail">{{ slot.formattedDate.split('|')[1] }}</div>
                          </div>
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>

                @if (selectedDate && futureTimeSlots?.length > 0) {
                  <div class="future-dropdown-container">
                    <mat-icon class="time-icon">access_time</mat-icon>
                    <mat-form-field class="time-dropdown">
                      <mat-select
                        placeholder="Select a time"
                        [(value)]="selectedTime"
                        (selectionChange)="setSelectedSlot($event.value, false)">
                        @for (slot of getTimeSlotsForDate(selectedDate); track slot) {
                          <mat-option [value]="slot.time" [disabled]="slot.disabled">
                            {{ slot.title }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                }
              </div>
            }
          </div>
        }
      </mat-radio-group>
    </div>

    <div class="continue-button-container">
      <button
        class="button-action-1 continue-button"
        (click)="handleContinue()"
        [disabled]="disableContinueButton || isLoading || (dateSelection === 'today' && !initialTime) || (dateSelection === 'future' && (!selectedDate || !selectedTime))"
        [class.disabled]="disableContinueButton || isLoading || (dateSelection === 'today' && !initialTime) || (dateSelection === 'future' && (!selectedDate || !selectedTime))">
        Continue
        <mat-icon>arrow_forward</mat-icon>
      </button>
    </div>
  }
</div>

